export const errorMessages = {
    CAMPAIGN_NOT_FOUND: "API Error: The campaign was not found."
}